











import Vue from 'vue';
import moment from 'moment';

export default Vue.extend({
  props: {
    customer: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      chatEnableImg: require('assets/img/chat-enable.svg'),
      chatDisabledImg: require('assets/img/chat-disabled.svg'),
    };
  },
  computed: {
    canChat(): boolean {
      if (this.customer.latelyInteractiveTime) {
        return moment().add(-2, 'days').format('YYYY-MM-DD hh:mm:ss') < this.customer.latelyInteractiveTime;
      } else {
        return false;
      }
    },
  },
  methods: {
    showChatBox() {
      this.$store.commit('HIDE_CHAT');
      this.$nextTick(() => {
        this.$store.commit('SHOW_CHAT', this.customer.openid);
      });
    },
  },
});
